import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import host from '../../urlPath';

//******* 

//--------- INSERT 
export const creatGroup = createAsyncThunk("creatGroup", async (formData, { rejectWithValue }) => {

    const response = await axios.post(`${host}/group_master.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data.success;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})



//--------- EDIT
export const updateGroup = createAsyncThunk("updateGroup", async (formData, { rejectWithValue }) => {

    const response = await axios.post(`${host}/group_master.php`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
    });

    try {
        const result = await response.data.success;
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})



//=---------- READ
//showGroupData
export const showGroupData = createAsyncThunk("showGroupData", async (args, { rejectWithValue }) => {

    const response = await fetch(`${host}/group_master.php`, {
        method: "GET", // *GET, POST, PUT, DELETE, etc. 
        headers: {
            "Content-Type": "application/json"
        }
    });
    try {
        const result = await response.json();
        return result;

    } catch (error) {
        return rejectWithValue(error)
    }
})



//--------- DELETE
export const deleteGroup = createAsyncThunk("deleteGroup", async (id, { rejectWithValue }) => {
    const response = await fetch(`${host}/group_master.php/${id}`, {
        method: "DELETE",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})





//--------- EDIT CLIENT
export const selectsinglegroup = createAsyncThunk("selectsinglegroup", async (id, { rejectWithValue }) => { 
    
    const response = await fetch(`${host}/group_master_edit.php/${id}`, {
        method: "GET",
        headers: {
            "Content-Type": "application/json",
        },
    });
    try {
        const result = await response.json();
        return result;
    }
    catch (error) {
        return rejectWithValue(error)
    }
})




//*************************************** FOR API END *************************


export const groupmaster = createSlice({
    name: "groupmaster",
    initialState: {
        groupdata: [],
        singlegroupdata: [],
        loading: false,
        error: null,
        groupIdName: "",
        groupNameCheck: "",
        urlparameterGroup: ""
    },
    //*************************************** FOR WITHOUT API ONLY FUNCTION START *************************   


    // //*************************************** FOR WITHOUT API ONLY FUNCTION START *************************   
    reducers: {
        changegroupIdName: (state, action) => {
            state.groupIdName = action.payload
        },
        changeUrlParameter: (state, action) => {
            state.urlparameterGroup = action.payload
        },
    },
    //*************************************** FOR WITHOUT API ONLY FUNCTION END *************************



    //*************************************** FOR API START *************************
    extraReducers: (builder) => {

        //-------------------- FOR INSERT -------------------------
        builder.addCase(creatGroup.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(creatGroup.fulfilled, (state, action) => {
            state.loading = false;
            state.groupNameCheck = action.payload;
        })
        builder.addCase(creatGroup.rejected, (state, action) => {
            state.loading = false;
            state.groupNameCheck = action.payload.message;
        })
        //---------------------- END --------------------------


        //---------------------- FOR SELECT ---------------------------
        builder.addCase(showGroupData.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(showGroupData.fulfilled, (state, action) => {
            state.loading = false;
            state.groupdata = action.payload;
            
        })
        builder.addCase(showGroupData.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


         //-------------------- FOR selectsingleclient  -------------------------
         builder.addCase(selectsinglegroup.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(selectsinglegroup.fulfilled, (state,action) => {
            state.singlegroupdata = action.payload; 
        })
        builder.addCase(selectsinglegroup.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------

        

        //---------------------- FOR DELETE ---------------------------
        builder.addCase(deleteGroup.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(deleteGroup.fulfilled, (state, action) => {
            state.loading = false; 
            if (action.payload.id) {
                state.groupdata = state.groupdata.filter((ele) => ele.id !== action.payload.id)
            }
        })
        builder.addCase(deleteGroup.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        })
        //---------------------- END --------------------------


        //-------------------- FOR UPDATE -------------------------
        builder.addCase(updateGroup.pending, (state) => {
            state.loading = true;
        })
        builder.addCase(updateGroup.fulfilled, (state, action) => {
            state.loading = false;
            state.groupNameCheck = action.payload;
        })
        builder.addCase(updateGroup.rejected, (state) => {
            state.loading = false;
        })
        //---------------------- END --------------------------




        //*************************************** FOR API END ************************* 
    },

});
export default groupmaster.reducer;
export const {changeUrlParameter,changegroupIdName} = groupmaster.actions; // FOR EXPORT REDUCERS